import { Nullable } from 'buzz_lib_building_blocks';

export type FormatTitleArgs = {
  ShowTitle?: Nullable<string>;
  SeasonTitle?: Nullable<string>;
  EpisodeNumber?: Nullable<number>;
  Title: string;
};

export const formatTitle = (args: FormatTitleArgs) => {
  if (isEpisode(args)) {
    return formatEpisodeTitle(args);
  }

  return args.Title;
};

const isEpisode = (args: FormatTitleArgs) => !!args.EpisodeNumber && !!args.SeasonTitle && !!args.ShowTitle;

const formatEpisodeTitle = (args: FormatTitleArgs) => {
  if (args.ShowTitle === args.SeasonTitle) {
    return `${args.ShowTitle}: Ep ${args.EpisodeNumber}: ${args.Title}`;
  }

  return `${args.ShowTitle}: ${args.SeasonTitle}: Ep ${args.EpisodeNumber}: ${args.Title}`;
};
